// Career
export const GET_CAREER_DATA = "GET_CAREER_DATA";
export const POST_CAREER_DATA = "POST_CAREER_DATA";

// Contact
export const GET_CONTACT_DATA = "GET_CONTACT_DATA";
export const UPDATE_CONTACT_DATA = "UPDATE_CONTACT_DATA";

// Principal
export const GET_PRINCIPAL_DATA = "GET_PRINCIPAL_DATA";
export const UPDATE_PRINCIPAL_DATA = "UPDATE_PRINCIPAL_DATA";

// Home
export const GET_HOME_DATA = "GET_HOME_DATA";
export const POST_HOME_DATA = "POST_HOME_DATA";

// About
export const GET_ABOUT_DATA = "GET_ABOUT_DATA";
export const POST_ABOUT_DATA = "POST_ABOUT_DATA";

// Covid
export const GET_COVID_DATA = "GET_COVID_DATA";
export const POST_COVID_DATA = "POST_COVID_DATA";

// Admission
export const GET_ADMISSION_DATA = "GET_ADMISSION_DATA";
export const UPDATE_ADMISSION_DATA = "UPDATE_ADMISSION_DATA";

// Team
export const GET_TEAM_DATA = "GET_TEAM_DATA";
export const UPDATE_TEAM_DATA = "UPDATE_TEAM_DATA";

// Login
export const SIGN_IN = "SIGN_IN";
export const LOGOUT = "LOGOUT";

// Gallery
export const GET_GALLERY_DATA = "GET_GALLERY_DATA";
export const POST_GALLERY_DATA = "POST_GALLERY_DATA";
export const DELETE_GALLERY_DATA = "DELETE_GALLERY_DATA";
export const ADD_GALLERY_DATA = "ADD_GALLERY_DATA";

// Parents
export const ADD_SCHOOL_POLICY = "ADD_SCHOOL_POLICY";
export const ADD_SCHOOL_NEWSLATER = "ADD_SCHOOL_NEWSLATER";
export const ADD_CALENDER = "ADD_CALENDER";
export const GET_SCHOOL_POLICY = "GET_SCHOOL_POLICY";
export const GET_SCHOOL_NEWSLATER = "GET_SCHOOL_NEWSLATER";
export const GET_CALENDER = "GET_CALENDER";
export const UPDATE_SCHOOL_POLICY = "UPDATE_SCHOOL_POLICY";
export const UPDATE_SCHOOL_NEWSLATER = "UPDATE_SCHOOL_NEWSLATER";
export const UPDATE_CALENDER = "UPDATE_CALENDER";
export const DELETE_SCHOOL_POLICY = "DELETE_SCHOOL_POLICY";
export const DELETE_SCHOOL_NEWSLATER = "DELETE_SCHOOL_NEWSLATER";
export const DELETE_CALENDER = "DELETE_CALENDER";

// Blogs
export const GET_BLOGS = "GET_BLOGS";
export const ADD_NEW_BLOG = "ADD_NEW_BLOG";
export const GET_BLOGS_BY_ID = "GET_BLOGS_BY_ID";
export const UPDATE_NEW_BLOG = "UPDATE_NEW_BLOG";

// Info
export const GET_INFO_DATA = "GET_INFO_DATA";
export const UPDATE_INFO_DATA = "UPDATE_INFO_DATA";

// Payment
export const PAYMENT = "PAYMENT";
